import React, { useMemo } from "react";
import DashboardWidgetCard from "./components/DashboardWidgetCard";
import DashboardCardHeader from "./components/DashboardCardHeader";

import { makeStyles } from "@material-ui/core";
import ToggleButtonsTrasnferList from "./components/ToggleButton";
import useFetch from "./hooks/useFetch";
import Loading from "./components/Loading";
import TargetVsAchivementWidget from "./TargetVsAchivementWidget";
import { formatDate } from "./helper/format";
import TargetVsAchivementBreakdown from "./TargetVsAchivementBreakdown";

const useStyle = makeStyles((theme) => {
  return {
    card: {
      margin: theme.spacing(2, 0),
    },
    cardHeader: {
      marginTop: theme.spacing(0.5),
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    updateDate: {
      color: "rgba(54, 43, 115, 0.56)",
      margin: "0",
      fontSize: 12,
    },
    container: {
      display: "flex",
      width: "100%",
      flexWrap: "wrap",
      paddingBottom: 16,
    },
    wrapper: {
      display: "flex",
      alignItems: "center",
      marginTop: 12,
      width: "100%",
      padding: theme.spacing(1, 2, 0),
    },
    item: {
      fontFamily: "Inter",
      width: "10%",
      color: "#E2136E",
      fontWeight: 500,
      fontSize: 12,
    },
  };
});

const config = (data) => [
  {
    header: "Acquisition",
    target: data.acquisition.target,
    achived: data.acquisition.achievement,
    remaining: data.acquisition.remaining,
    dailyRequired: data.acquisition.daily_required,
  },
  {
    header: "Payment Amount",
    target: data.payment.target,
    achived: data.payment.achievement,
    remaining: data.payment.remaining,
    dailyRequired: data.payment.daily_required,
    achievementEligible: data.payment.achievement_eligible,
    remainingEligible: data.payment.remaining_eligible,
    dailyRequiredEligible: data.payment.daily_required_eligible,
    isEligible: true,
  },
  {
    header: "Active Merchant", // (5 MAU 1500 Payment)",
    target: data.active_merchant.target,
    achived: data.active_merchant.achievement,
    remaining: data.active_merchant.remaining,
    dailyRequired: data.active_merchant.daily_required,
    achievementEligible: data.active_merchant.achievement_eligible,
    remainingEligible: data.active_merchant.remaining_eligible,
    dailyRequiredEligible: data.active_merchant.daily_required_eligible,
    isEligible: true,
  },
  {
    header: "Bill Payment", // (Count)",
    target: data.bill_payment.target,
    achived: data.bill_payment.achievement,
    remaining: data.bill_payment.remaining,
    dailyRequired: data.bill_payment.daily_required,
  },

  {
    header: "App Login",
    target: data.app_login.target,
    achived: data.app_login.achievement,
    remaining: data.app_login.remaining,
    dailyRequired: data.app_login.daily_required,
  },
];

const tabConfig = () => [
  { label: "MTD Target" },
  { label: "Monthly Target" },
  // { label: "Daily" },
];

const tabConfigOverall = [{ label: "Eligible" }, { label: "Total" }];

function TargetVsAchivement({ geoFilters }) {
  const params = useMemo(() => geoFilters, [geoFilters]);
  const { data, isLoading } = useFetch(
    "/reports/dashboard/target-vs-achievement",
    params
  );
  const classes = useStyle();
  const [tabIndex, setTabIndex] = React.useState(0);
  const [tabIndexOverall, setTabIndexOverall] = React.useState(0);

  const onTabChange = (index) => {
    if (index == null) return;
    setTabIndex(index);
  };
  const onTabChangeOverall = (index) => {
    if (index == null) return;
    setTabIndexOverall(index);
  };

  return (
    <DashboardWidgetCard className={classes.card}>
      <DashboardCardHeader
        className={classes.cardHeader}
        label="Target vs Achievement"
        subLabel={
          data && (
            <p className={classes.updateDate}>
              Updated till - {formatDate(data.last_parsed_time)}
            </p>
          )
        }
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <ToggleButtonsTrasnferList
            config={tabConfig()}
            {...{ tabIndex, onTabChange }}
          />
          <div style={{ marginLeft: 12 }}>
            <ToggleButtonsTrasnferList
              config={tabConfigOverall}
              tabIndex={tabIndexOverall}
              onTabChange={onTabChangeOverall}
            />
          </div>
          {
            <div style={{ marginLeft: 12 }}>
              <TargetVsAchivementBreakdown />
            </div>
          }
        </div>
      </DashboardCardHeader>
      {isLoading ? (
        <Loading />
      ) : (
        data && (
          <div className={classes.container}>
            <div
              className={classes.wrapper}
              style={{
                marginBottom: 16,
              }}
            >
              <div className={classes.item} style={{ width: "20%" }}>
                Item
              </div>
              <div className={classes.item} style={{ textAlign: "center" }}>
                Target
              </div>
              <div className={classes.item} style={{ textAlign: "center" }}>
                Achievement
              </div>
              <div className={classes.item} style={{ textAlign: "center" }}>
                %
              </div>
            </div>
            {config(data).map((element, _i) => {
              return (
                <TargetVsAchivementWidget
                  element={element}
                  tabIndex={tabIndex}
                  index={_i}
                  key={_i}
                  isLast={_i === config(data).length}
                  isInEligibleTab={
                    element.isEligible &&
                    tabConfigOverall[tabIndexOverall].label === "Eligible"
                  }
                  lastParsedTime={data.last_parsed_time}
                />
              );
            })}
          </div>
        )
      )}
    </DashboardWidgetCard>
  );
}

export default TargetVsAchivement;
